// Shared sectors and KPIs for Performance KPI module (Sector Management, Evaluation, etc.)

export const sectors = [
  { id: "raw-nut-receiving", name: "Raw Nut Receiving" },
  { id: "steam-roasting", name: "Steam Roasting" },
  { id: "shelling", name: "Shelling" },
  { id: "peeling", name: "Peeling" },
  { id: "grading", name: "Grading" },
];

// KPIs used for evaluation (id, name, definition, iconColor for UI). Same set used per sector for now.
export const sectorKpis = [
  {
    id: "kpi-1",
    name: "Moisture Content (%)",
    definition: "Percentage of water in raw cashew nuts; ideal range is 8-10% to prevent fungal growth.",
    iconColor: "text-blue-500",
  },
  {
    id: "kpi-2",
    name: "Kernel Integrity",
    definition: "Ratio of whole kernels vs. brokens after initial processing and test-shelling.",
    iconColor: "text-emerald-500",
  },
  {
    id: "kpi-3",
    name: "Grading Accuracy",
    definition: "Precision in categorizing nuts by size and quality grades (e.g., WW240, WW320).",
    iconColor: "text-purple-500",
  },
  {
    id: "kpi-4",
    name: "Daily Throughput",
    definition: "Total tonnage of raw nuts processed and cleared through the receiving station per shift.",
    iconColor: "text-amber-500",
  },
  {
    id: "kpi-5",
    name: "Safety Protocol Adherence",
    definition: "Compliance with factory floor safety standards and PPE usage in the receiving zone.",
    iconColor: "text-orange-500",
  },
];

// Training topics for operator training (similar to KPIs). Same set used per sector.
export const trainingTopics = [
  { id: "tt-1", name: "Safety & PPE", definition: "Personal protective equipment, hazard awareness, and emergency procedures.", iconColor: "text-orange-500" },
  { id: "tt-2", name: "Equipment operation", definition: "Correct use of sector machinery and daily checks.", iconColor: "text-blue-500" },
  { id: "tt-3", name: "Quality standards", definition: "Product specs, grading, and defect identification.", iconColor: "text-emerald-500" },
  { id: "tt-4", name: "Process flow", definition: "Workstation sequence, handoffs, and documentation.", iconColor: "text-purple-500" },
  { id: "tt-5", name: "Hygiene & GMP", definition: "Good manufacturing practice and hygiene in the work area.", iconColor: "text-amber-500" },
];
